import TomSelect from 'tom-select/dist/js/tom-select.base.js'

TomSelect.define('remove_button', require('tom-select/dist/js/plugins/remove_button.js'))
TomSelect.define('no_backspace_delete', require('tom-select/dist/js/plugins/no_backspace_delete.js'))

export default function () {
  let config = {
    plugins: {
      'no_backspace_delete': {},
      'remove_button': {
        title: 'Entfernen',
        label: '<span aria-hidden="true">&times;</span><span class="sr-only">Entfernen</span>'
      }
    },
    render: {
      no_results: function (data, escape) {
        return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '"</div>'
      }
    }
  }

  let tomSelects = []
  let selects = document.querySelectorAll('.js-multiple-select')
  selects.forEach((el) => {
    let tomSelect = new TomSelect(el, config)
    tomSelects.push(tomSelect)
  })

  let resetButton = document.querySelector('button[type="reset"]')
  if (resetButton) {
    resetButton.addEventListener('click', function () {
      tomSelects.forEach(function (tomSelect) {
        tomSelect.clear()
      })

      selects.forEach(function (select) {
        let options = select.querySelectorAll('option[selected="selected"]')
        options.forEach(function (option) {
          option.removeAttribute('selected')
        })
      })
    })
  }
}
